import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DateInfo.html?raw';
import on from 'dojo/on';
import FloatingContainer from '../../moreCore/UI/Floating/FloatingContainer';
import { WebcalendarTypes } from "../../moreCore/UI/moreCoreCalendar/WebCalendarTypes";
import GenericEntityView from '../../moreCore/UI/EntityBased/EntityView/GenericEntityView';
import { EntityViewTypes } from "../../moreCore/UI/EntityBased/EntityView/EntityViewTypes";
import { ColorHelpers, DateHelpers } from "../../more/Helpers";

interface setupConfig {
    position: "fixed" | "absolute",
    targetDate: Date,
    node: HTMLElement,
    evt?: MouseEvent,
    activeFilterIDs: Array<string>
    activeSubfilterIDs: Array<string>
}


interface DateInfoData {
    holidayViewdata: Array<EntityViewTypes.EntityViewResponse<any>>;
    holidays: Array<WebcalendarTypes.Holiday>;
    viewData: EntityViewTypes.EntityViewResponse<any>;
}
class WebcalendarDateInfo extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private txtHeading: HTMLElement;
    private holidaysContainer: HTMLElement;
    private entityViewContainer: HTMLElement;
    private spinnerContainer: HTMLElement;

    private _config: setupConfig;

    private _float: MdsLax<InstanceType<typeof FloatingContainer>>;

    setup(config: setupConfig) {
        this._config = config;

        if (!this._config) return;

        this.txtHeading.innerHTML = this.dateTimeToString(this._config.targetDate, "EEEE dd.MM.yyyy");
        let dateStr = this.dateToLocalISOString(this._config.targetDate);
        let nowStr = this.dateToLocalISOString(new Date());
        if (dateStr == nowStr) {
            this.UiModder.domClass.add(this.domNode, "today");
        }

        
        let floating = new FloatingContainer();

        if (config.position == "fixed") {
            floating.open(this._config.evt, this.domNode);
        } else {
            floating.openSimple({
                evtSource: this._config.evt,
                content: this.domNode,
                alternativeTarget: this._config.node,
                nodeClass: "floatingCalendarDate"
            });
        }

        this._float = floating;

        this._getDateInfoData();
    }

    private _requestHandle: dojo.request.Promise<any>;
    private _getDateInfoData() {
        this._requestHandle = this.RequestManager.callfunction(
            "Webtool_API_Webcalendar__GetDateInfoData",
            {
                date: this.dateToLocalISOString(this._config.targetDate),
                selectedHtFilters: this._config.activeFilterIDs,
                selectedSubFilters: this._config.activeSubfilterIDs
            },
            lang.hitch(this, this._onGetDateInfoDataResponse),
            lang.hitch(this, this._onGetDateInfoDataError)
        );
    }

    private _onGetDateInfoDataError(error: more.requestErrorMessage) {
        this._requestHandle = null;

        setTimeout(lang.hitch(this, this._getDateInfoData), 2000);
    }

    private _onGetDateInfoDataResponse(data: DateInfoData) {
        this._requestHandle = null;


        if (data.viewData && data.viewData.content) {
            let entityview = new GenericEntityView();
            entityview.setNonInteractive(true);
            entityview.setupWithoutEntity(data.viewData, null, this.entityViewContainer);
            this.hideNode(this.entityViewContainer, false);
        }

        if (data.holidays) {
            this.hideNode(this.holidaysContainer, data.holidays.length == 0);

            for (let holiday of data.holidays) {
                let holidiv = this.UiModder.domConstruct.create("div", {
                    className: "holiday"
                }, this.holidaysContainer);
                let header = this.UiModder.domConstruct.create("div", {
                    className: "head"
                }, holidiv);

                let titleGrp = this.UiModder.domConstruct.create("div", {
                    className: "titleGrp"
                }, header);

                this.UiModder.domConstruct.create("div", {
                    className: "headTitle",
                    innerHTML: holiday.description
                }, titleGrp);
                
                holidiv.style.setProperty("--holidayColorBG", ColorHelpers.getHexColorFromProperty(holiday.color, "BG"));
                holidiv.style.setProperty("--holidayColorTXT", ColorHelpers.getHexColorFromProperty(holiday.color, "TXT"));

                let dateRange: string = "";
                let dateStartStr = "";
                let dateEndStr = "";
                if (holiday.date_start) dateStartStr = DateHelpers.dateToString(holiday.date_start, "EEEE dd.MM.yyyy");
                if (holiday.date_end) dateEndStr = DateHelpers.dateToString(holiday.date_start, "EEEE dd.MM.yyyy");

                dateRange = dateStartStr;
                if (dateStartStr != dateEndStr) {
                    dateRange += " - " + dateEndStr;
                } 
                this.UiModder.domConstruct.create("div", {
                    className: "headSubtitle",
                    innerHTML: dateRange
                }, titleGrp);

                if (data.holidayViewdata) {
                    for (let holidayViewdata of data.holidayViewdata) {
                        if (holidayViewdata.entityId == holiday.ID) {
                            let container = this.UiModder.domConstruct.create("div", {
                                className: "holidayViewcontainer"
                            }, holidiv);
                            let holiview = new GenericEntityView();
                            holiview.setNonInteractive(true);
                            holiview.setupWithoutEntity(holidayViewdata, holiday.description, container);

                            this.UiModder.domClass.add(holidiv, "clickable");
                            on(holidiv, "click", lang.hitch(this, this._onClick_Holiday, holidiv));

                            break;
                        }
                    }
                }

                

            }
        }

       

        this.hideNode(this.spinnerContainer);

       
    }

    private _onClick_Holiday(node: HTMLElement, evt: MouseEvent) {
        let holidayNodes = this.domNode.querySelectorAll(".holiday");
        for (let i = 0; i < holidayNodes.length; i++) {
            let otherNode = holidayNodes[i];
            if (otherNode != node) {
                this.UiModder.domClass.remove(node, "expanded");
            }
        }
        this.UiModder.domClass.toggle(node, "expanded");
    }

    private _onClick_RootNode(evt: MouseEvent) {
        if (evt && evt.stopPropagation) evt.stopPropagation();
    }

    private _onClick_Close(evt: MouseEvent) {
        if (!this._destroyed) {
            this._float.close(evt);
        }
    }

    destroy(): void {
        if (this._requestHandle) {
            this._requestHandle.cancel();
            this._requestHandle = null;
        }
        super.destroy.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        ///
        this.RequestManager.handleAs = "jsonWithDate";
        this.useStandbyManager = true;

    }

    startup(): void {
        super.startup.apply(this, arguments as any);


    }


}

export default mdsWidget(WebcalendarDateInfo);